
import {CONSTANTS} from "../js/meta_data";
import {escapeHtml} from "./globalUtils";
import {HTMLPrinter} from "./htmlprinter";
import {CountryListLoader} from "./countryListLoader";

export interface LokalisierungsProvider {
    translate(key:string, fallback?:string):string;
    getlocalizedState(landIso, stateIso);
    getlocalizedLand(landIso);
    getSprache();
    getLocale();
    getDateFormat();
    getFirstDayOfTheWeekForCalendar():number;
    getUsernameAnrede(username):string;
    getMinimumFractionDigitsByLocale():number;
    localizeCurrency(symbol, amount):string;
    formatPreis(preis):string;
    keyExists(key):boolean;
    setTexte(texte):void,
    getPreisZusatzText(lieferlandIsEUStaat, inklusiveMwSt):string
}

export class DummyLocalizer implements LokalisierungsProvider {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    formatPreis(preis): string {
        return "";
    }

    getDateFormat() {
        return "";
    }

    getFirstDayOfTheWeekForCalendar(): number {
        return 0;
    }

    getLocale() {
        return "de-DE";
    }

    getMinimumFractionDigitsByLocale(): number {
        return 0;
    }

    getSprache() {
        return "de";
    }

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    getUsernameAnrede(username): string {
        return "Dude";
    }

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    getlocalizedLand(landIso) {
        return "Deutschland";
    }

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    getlocalizedState(landIso, stateIso) {
        return "";
    }

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    keyExists(key): boolean {
        return false;
    }

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    localizeCurrency(symbol, amount): string {
        return "EUR";
    }

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    setTexte(texte): void {
    }

    translate(key:string, fallback?:string): string {
        return fallback!=null? fallback:key;
    }

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    getPreisZusatzText(lieferlandIsEUStaat, inklusiveMwSt): string {
        return "incl MwSt zzgl. Versandkosten";
    }

}

export class Localizer implements LokalisierungsProvider {

    public constructor(language, locale, country) {
        LocalizerStatic.country = country;
        LocalizerStatic.language = language;
        LocalizerStatic.locale = locale;
    }

    public setTexte = texte=>LocalizerStatic.setTexte(texte);
    public keyExists = key=>LocalizerStatic.keyExists(key);
    public getLocale = ()=>LocalizerStatic.locale;
    public getSprache = ()=>LocalizerStatic.language;
    public getFirstDayOfTheWeekForCalendar = ()=>LocalizerStatic.getFirstDayOfTheWeekForCalendar();
    public translate = (key:string, defaultText="")=>LocalizerStatic.translate(key, defaultText);
    getMinimumFractionDigitsByLocale = ()=>LocalizerStatic.getMinimumFractionDigitsByLocale()
    localizeCurrency = (symbol, amount)=>LocalizerStatic.localizeCurrency(symbol, amount);
    getlocalizedLand = (landIso)=>LocalizerStatic.getlocalizedLand(landIso);
    getlocalizedState = (landIso, stateIso)=>LocalizerStatic.getlocalizedState(landIso, stateIso)
    public getDateFormat = ()=>LocalizerStatic.getDateFormat()
    getUsernameAnrede =(username)=>LocalizerStatic.getUsernameAnrede(username)
    formatPreis = (preis:string)=>LocalizerStatic.formatPreis(preis);
    getPreisZusatzText = (lieferlandIsEUStaat, inklusiveMwSt)=>LocalizerStatic.getPreisZusatzText(lieferlandIsEUStaat, inklusiveMwSt)
}

export class LocalizerStatic {
    public static texte:string[]|null = null;
    public static country;
    public static language;
    public static locale;

    public constructor(language, locale, country) {
        LocalizerStatic.country = country;
        LocalizerStatic.language = language;
        LocalizerStatic.locale = locale;
    }

    public static setTexte = texte=>LocalizerStatic.texte = texte;
    public static keyExists = (key:string)=>LocalizerStatic.texte !== null && LocalizerStatic.texte[key.toLowerCase()] !== undefined;
    public static getLocale = ()=>LocalizerStatic.locale;
    public static getSprache = ()=>LocalizerStatic.language;
    public static getFirstDayOfTheWeekForCalendar = ()=>(["us", "ca"].indexOf(LocalizerStatic.country.toLowerCase()) > -1) ? 0 : 1;
    public static translate = (key:string, defaultText="")=> LocalizerStatic.keyExists(key.toLowerCase()) ? (LocalizerStatic.texte as string[])[key.toLowerCase()] : LocalizerStatic.getFallBack(key, defaultText)

    private static getFallBack(key:string, defaultText) {
        return "[" + defaultText + "]";
    }
    public static getMinimumFractionDigitsByLocale(){
        switch(LocalizerStatic.locale){
            case "ja-JP":
                return 0;
            default:
                return 2;
        }
    }

    public static localizeCurrency(symbol, amount){
        if(['¥', '円', 'JPY'].indexOf(symbol)>=0){
            symbol = '円';
            return (parseFloat(amount)).toLocaleString("ja-JP", {minimumFractionDigits: 0}) + symbol;
        }
        else if(['원', 'KRW'].indexOf(symbol)>=0){
            //symbol = '원';
            symbol = '€';
            return (parseFloat(amount)).toLocaleString("ko-KR", {minimumFractionDigits: 0}) + symbol;
        }
        else{
            return symbol + ' ' + (parseFloat(amount)).toLocaleString(LocalizerStatic.locale, {minimumFractionDigits: 2});
        }
    }

    public static getlocalizedLand(landIso) {
        return CountryListLoader.getlocalizedLand(landIso);
    }

    public static getlocalizedState(landIso, stateIso) {
        return CountryListLoader.getlocalizedState(landIso, stateIso);
    }

    public static getDateFormat() {
        const d = CONSTANTS.DATEFORMAT_BYLANGUAGE;
        return typeof (d[LocalizerStatic.language.toLowerCase()]) !== "undefined" ? d[LocalizerStatic.language.toLowerCase()] : d.default;
    }

    public static getUsernameAnrede(username): string {
        const hello = LocalizerStatic.translate("konf_hello");
        const escapedUsername = escapeHtml(username);
        return LocalizerStatic.country === "jp" ? HTMLPrinter.sentence(escapedUsername, hello)
            : HTMLPrinter.sentence(hello, escapedUsername);
    }

    public static formatPreis(preis:string):string {
        return parseFloat(preis).toLocaleString(
            LocalizerStatic.locale,
            {minimumFractionDigits: LocalizerStatic.getMinimumFractionDigitsByLocale()}
        );
    }

    public static getPreisZusatzText(lieferlandIsEUStaat, inklusiveMwSt) {
        const inclMwst = lieferlandIsEUStaat || inklusiveMwSt;
        return inclMwst ?
            LocalizerStatic.translate("konfi_inklMWST", "inkl. MwSt. zzgl. Versandkosten") :
            LocalizerStatic.translate("konfi_exklMWST", "exkl. MwSt. zzgl. Versandkosten");
    }
}

(window as any).LocalizerStatic = LocalizerStatic;
